<template>
    <div 
        class="history"
        style="border: 1px solid #a3a3a3;
        border-radius: 10px;"
    >
        <DataTable 
            :value="history" 
            v-model:filters="filters"
            paginator 
            :rows="5" 
            :rowsPerPageOptions="[5, 10, 20, 50]"
            tableStyle="width: auto" 
            :reorderableColumns="true" 
            filterDisplay="row"
            :globalFilterFields="Object.keys(filters)"
            @filter="onFilter"
            ref="dt"
            style="border-radius: 10px;"
        >
            <template #header>
                <div class="coloumns" style="text-align:left; border-radius: 10px;">
                    <MultiSelect 
                        :modelValue="selectedColumns" 
                        :options="columns" 
                        optionLabel="header"
                        @update:modelValue="onToggle" 
                        display="chip" 
                        placeholder="Выберите колонки"
                        style="max-width: 20rem" />
                </div>
            </template>
            <ColumnTable v-for="(col) of selectedColumns" :field="col.field" :header="col.header" :key="col.field"
                sortable>
                <template #body="{ data }">
                    <Skeleton v-if="loading"></Skeleton>
                    <span v-else>{{ data[col.field] }}</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                        placeholder="Поиск по" />
                </template>
            </ColumnTable>
        </DataTable>
    </div>
    <div class="analytics">
        <div class="statistic">
            <div class="statistic">
                <div 
                    v-for="item of statistic"
                    :key="item.label"
                    class="statistic-item"
                >
                    <span class="statistic-item__label">{{ item.label }}</span>
                    <span class="statistic-item__value">{{ item.value }}</span>
                </div>                
            </div>
        </div>
        <Chart type="line" :data="chartData" :options="chartOptions" class="h-[30rem]" />
    </div>
</template>

<script>
import axios from 'axios';

import Skeleton from 'primevue/skeleton';
import Chart from 'primevue/chart';
import { FilterMatchMode } from '@primevue/core/api';

export default {
    components: {
        Skeleton,
        Chart
    },
    data() {
        return {
            history: new Array(10),
            columns: [
                { field: 'status', header: 'Статус' },
                { field: 'last_date', header: 'Дата последнего сообщения' },
                { field: 'err', header: 'Ошибка' },
                { field: 'send_date', header: 'Дата отправки' },
                { field: 'phone', header: 'Телефон' },
                { field: 'country', header: 'Страна' },
                { field: 'operator', header: 'Оператор' },
                { field: 'region', header: 'Регион' },
                { field: 'type', header: 'Тип' },
                { field: 'cost', header: 'Стоимость' },
                { field: 'status_name', header: 'Название статуса' },
                { field: 'message', header: 'Сообщение' },
                { field: 'mccmnc', header: 'MCCMNC' },
                { field: 'id', header: 'ID' },
                { field: 'int_id', header: 'ID внутренний' },
                { field: 'sms_cnt', header: 'Количество СМС' },
                { field: 'format', header: 'Формат' },
                { field: 'crc', header: 'CRC' },
                { field: 'flag', header: 'Флаг' },
                { field: 'sender_id', header: 'ID отправителя' },
                { field: 'comment', header: 'Комментарий' }
            ],
            selectedColumns: [
                { field: 'status', header: 'Статус' },
                { field: 'last_date', header: 'Дата последнего сообщения' },
                { field: 'send_date', header: 'Дата отправки' },
                { field: 'phone', header: 'Телефон' },
                { field: 'country', header: 'Страна' },
                { field: 'region', header: 'Регион' },
                { field: 'cost', header: 'Стоимость' },
                { field: 'message', header: 'Сообщение' },
                { field: 'sms_cnt', header: 'Количество СМС' },
            ],
            filters: {
                status: { value: null, matchMode: FilterMatchMode.CONTAINS },
                last_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
                err: { value: null, matchMode: FilterMatchMode.CONTAINS },
                send_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
                phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
                country: { value: null, matchMode: FilterMatchMode.CONTAINS },
                operator: { value: null, matchMode: FilterMatchMode.CONTAINS },
                region: { value: null, matchMode: FilterMatchMode.CONTAINS },
                type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                cost: { value: null, matchMode: FilterMatchMode.CONTAINS },
                status_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                message: { value: null, matchMode: FilterMatchMode.CONTAINS },
                mccmnc: { value: null, matchMode: FilterMatchMode.CONTAINS },
                id: { value: null, matchMode: FilterMatchMode.CONTAINS },
                int_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
                sms_cnt: { value: null, matchMode: FilterMatchMode.CONTAINS },
                format: { value: null, matchMode: FilterMatchMode.CONTAINS },
                crc: { value: null, matchMode: FilterMatchMode.CONTAINS },
                flag: { value: null, matchMode: FilterMatchMode.CONTAINS },
                sender_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
                comment: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            loading: true,
            filteredRows: [],
            chartData: null,
            chartOptions: null,
            statistic: []
        }
    },
    methods: {
        async getHistory() {
            try {
                const time = ['last_date', 'send_date']
                const response = await axios.get('https://ncht.bz/api/sms/get-sms-history');
                let data = response.data;
                data.forEach(item => {
                    Object.keys(item).forEach(key => {
                        if (time.includes(key)) {
                            item[key] = new Date(item[key]).toLocaleString();
                        }
                        if (key === 'err') {
                            item[key] = this.replaceError(item[key]);
                        }
                        if (key === 'status') {
                            item[key] = this.replaceStatus(item[key]);
                        }
                        if (key === 'phone') {
                            item[key] = item[key].slice(0, 4) + '*'.repeat(item[key].length - 4);
                        }
                    });
                });
                this.history = data;
                this.loading = false;
                this.createChart();
            } catch (error) {
                console.error('Ошибка получения данных:', error);
            }
        },
        async getHeader() {
            const toDelete = ['sender', 'operator_orig', 'send_retry']
            const response = await axios.get('https://ncht.bz/api/sms/get-sms-history-header');
            const data = response.data;
            this.columns = data.filter(item => !toDelete.includes(item));
        },
        async createChart() {
            const startDate = new Date('2025.03.14');
            const endDate = new Date('2025.04.24');
            const step = 5; //5 дней
            const labels = Array.from({ length: Math.ceil((endDate - startDate) / (step * 86400000)) + 1 }, (_, i) => {
                const date = new Date(startDate);
                date.setDate(startDate.getDate() + i * step);
                return date.toLocaleDateString();
            });
            const scaleTimestamps = labels.map(date => {
                const [day, month, year] = date.split('.').map(Number);
                console.log(year, month, day, new Date(year, month - 1, day, 23, 59, 59, 999).getTime())
                return new Date(year, month - 1, day, 23, 59, 59, 999).getTime();
            });
            const dataSource = (this.filteredRows && this.filteredRows.length) ? this.filteredRows : this.history;
            const timestamps = dataSource
                .filter(item => item && item.send_timestamp)
                .reverse()
                .map((item, index) => ({
                    timestamp: parseInt(item.send_timestamp + '999'),
                    index
                }));
            timestamps.sort((a, b) => a.timestamp - b.timestamp);
            const result = new Array(labels.length).fill(0);
            let dataIndex = 0;
            let count = 0;
            for (let i = 0; i < scaleTimestamps.length; i++) {
                while (
                dataIndex < timestamps.length &&
                timestamps[dataIndex].timestamp <= scaleTimestamps[i]
                ) {
                    count++;
                    dataIndex++;
                }
                result[i] = count;
                count = 0;
            }
            this.chartData = {
                labels: labels,
                datasets: [
                    {
                        label: 'Количество номеров в рассылке',
                        fill: false,
                        yAxisID: 'y',
                        tension: 0.4,
                        data: result
                    }
                ]
            }
            await this.getStatistic();
        },
        async getStatistic() {
            this.statistic = [
                {
                    label: 'Всего',
                    value: this.history.length
                }
            ];

            Object.keys(this.statuses).forEach(item => {
                const count = this.history.filter(item => item.status === item).length;
                if (count > 0) {
                    this.statistic.push({
                        label: this.statuses[item],
                        value: count
                    })
                }
            })
            
        },
        replaceError(item) {
            return this.errors[parseInt(item)] || '';
        },
        replaceStatus(item) {
            return this.statuses[item] || '';
        },
        onToggle(value) {
            this.selectedColumns = this.columns.filter(col => value.includes(col));
        },
        onFilter(event) {
            this.filteredRows = event.filteredValue;
            this.createChart(); // Обновляем график при фильтрации
        },
    },
    async mounted() {
        this.getHistory();
    },
    beforeUnmount() {
        if (this.eventSource) {
            this.eventSource.close();
        }
    },
    computed: {
        statuses() {
            return {
                '-3': 'Сообщение не найдено',
                '-2': 'Остановлено',
                '-1': 'Ожидает отправки',
                '0': 'Передано оператору',
                '1': 'Доставлено',
                '2': 'Прочитано',
                '3': 'Просрочено',
                '4': 'Нажата ссылка',
                '20': 'Невозможно доставить',
                '22': 'Неверный номер',
                '23': 'Запрещено',
                '24': 'Недостаточно средств',
                '25': 'Недоступный номер'
            };
        },
        errors() {
            return {
                1: 'Абонент не существует',
                6: 'Абонент не в сети',
                11: 'Не подключена услуга',
                12: 'Ошибка в телефоне абонента',
                13: 'Абонент заблокирован',
                21: 'Нет поддержки сервиса',
                200: 'Виртуальная отправка',
                219: 'Замена sim-карты',
                220: 'Переполнена очередь у оператора',
                237: 'Абонент не отвечает',
                238: 'Нет шаблона',
                239: 'Запрещенный ip-адрес',
                240: 'Абонент занят',
                241: 'Ошибка конвертации',
                242: 'Зафиксирован автоответчик',
                243: 'Не заключен договор',
                244: 'Рассылка запрещена',
                245: 'Статус не получен',
                246: 'Ограничение по времени',
                247: 'Превышен лимит сообщений',
                248: 'Нет маршрута',
                249: 'Неверный формат номера',
                250: 'Номер запрещен настройками',
                251: 'Превышен лимит на один номер',
                252: 'Номер запрещен',
                253: 'Запрещено спам-фильтром',
                254: 'Незарегистрированный sender id',
                255: 'Отклонено оператором'
            }
        }
    }
}
</script>
<style>
.p-datatable-header,
.p-datatable-paginator-bottom {
    border-radius: 10px;
}
</style>